<template>
  <v-combobox
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Brand"
    item-text="brand"
    item-value="brand"
    :return-object=false
    :disabled="disabled"
    :rules="rules"
    clearable
  ></v-combobox>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: ["value", "disabled", "shopId", "rules"],
  watch: {
    model() {
      this.$emit("input", this.model);
    }
  },
  mounted: function() {
    this.getFittingType();
  },
  methods: {
    ...mapActions("brand",["list"]),
    getFittingType() {
      this.list()
        .then(data => {
          this.items = data.brands.data;
        });
    }
  }
};
</script>
